const getItem = (key: string) => {
  return sessionStorage.getItem(key);
};

const setItem = <T>(key: string, value: T) => {
  return sessionStorage.setItem(key, JSON.stringify(value));
};

const getJSONItem = <T>(key: string, fallback: null | T = null) => {
  const item = getItem(key);
  if (!item) {
    return fallback;
  }
  return JSON.parse(item);
};

const removeItem = (key: string) => {
  sessionStorage.removeItem(key);
};

export { getItem, setItem, getJSONItem, removeItem };
